import { Routes } from '@angular/router';
import { GetCareNowComponent as GetCareNowMobile } from './get-care-now-feature/mobile/components/get-care-now/get-care-now.component';
import { GetCareNowComponent as GetCareNow } from './get-care-now-feature/web/components/get-care-now/get-care-now.component';
import { ErrorNotFoundComponent } from './shared/components/error-not-found/error-not-found.component';
import { AuthGuardService } from './shared/services/auth/authguard.service';
import { ErrorUnauthorizedComponent } from './shared/components/error-unauthorized/error-unauthorized.component';
import { NeedHelpDecidingChatBotComponent } from './shared/components/chat-bot/chat-bot.component';
import { ProviderLocationSearchContainerComponent } from './provider-location-search-feature/web/provider-location-search-container/provider-location-search-container.component';
import { ProviderLocationSearchContainerComponent as ProviderLocationSearchContainerMobile } from './provider-location-search-feature/mobile/components/provider-location-search-container/provider-location-search-container.component';
import { PreLoginComponent as PreLoginComponentMobile} from './pre-login-feature/mobile/components/pre-login/pre-login.component';
import { PreLoginComponent as PreLoginComponentWeb } from './pre-login-feature/web/components/pre-login/pre-login.component';
import { ProviderLocationSearchResultsComponent } from './provider-location-search-feature/web/provider-location-search-results/provider-location-search-results.component';
import { ProviderSearchDetailsComponent } from './provider-location-search-feature/mobile/components/provider-search-details/provider-search-details.component';
import { LocationSearchDetailsComponent } from './provider-location-search-feature/web/location-search-details/location-search-details.component';
import { LocationSearchDetailsComponent as LocationSearchDetailsMobile } from './provider-location-search-feature/mobile/components/location-search-details/location-search-details.component';
import { BedsideSurveyComponent } from './mychart-bedside-survey-feature/web/components/bedside-survey/bedside-survey.component';

export const routes: Routes = [
    {
        path: 'pre-login',
        title: 'Home',
        component: PreLoginComponentWeb,
    },
    {
        path: 'pre-login/mobile',
        title: 'Home',
        component: PreLoginComponentMobile,
    },
    {
        path: 'get-care-now',
        title: 'Get Care Now',
        component: GetCareNow,
        canActivate: [AuthGuardService],
    },
    {
        path: 'get-care-now/mobile',
        title: 'Get Care Now',
        component: GetCareNowMobile,
        canActivate: [AuthGuardService],
    },
    {
        path: 'find-care',
        title: 'Find a Provider',
        component: ProviderLocationSearchContainerComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'find-care/mobile',
        title: 'Find a Provider',
        component: ProviderLocationSearchContainerMobile,
        canActivate: [AuthGuardService], // Temporarily disabled for testing
    },
    {
        path: 'mobile/provider-details',
        title: 'Provider Details',
        component: ProviderSearchDetailsComponent,
        // canActivate: [AuthGuardService], // Temporarily disabled for testing
    },
    {
        path: 'mobile/location-details',
        title: 'Location Details',
        component: LocationSearchDetailsMobile,
        // canActivate: [AuthGuardService], // Temporarily disabled for testing
    },
    {
        path: 'find-care/location-details',
        title: 'Location Details',
        component: LocationSearchDetailsComponent,
        // canActivate: [AuthGuardService], // Temporarily disabled for testing
    },
    {
        path: 'find-care/results',
        title: 'Find a Provider',
        component: ProviderLocationSearchResultsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'bedside-survey',
        title: 'myChart Bedside Survey',
        component: BedsideSurveyComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'unauthorized',
        title: 'Unauthorized',
        component: ErrorUnauthorizedComponent
    },
    {
        path: 'not-found',
        title: 'Not Found',
        component: ErrorNotFoundComponent
    },
    {
        path: '**',
        redirectTo: 'not-found',
    }
];
